import { Icons } from '@assets/svg'
import { colors } from '@config/theme'
import { useMediaQuery } from '@mui/material'
import { Button } from '@stories/Theme/Button/Button'
import { Text } from '@stories/Typography/Text/Text'
import mixpanel from 'mixpanel-browser'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const BackIcon = Icons['back']
const LTSVG = Icons['error404lefttopsvg']
const RTSVG = Icons['error404rightopsvg']
const LBSVG = Icons['error404leftbottomsvg']
const RBSVG = Icons['error404rightbottomsvg']

const ErrorContainerWrapper = styled.div`
  padding: 10rem 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  .left-top {
    z-index: 2;
    display: none;
    @media${({ theme }) => theme.device['lg']} {
      display: block;
      position: absolute;
      left: 20%;
      top: 30%;
    }
  }
  .right-top {
    z-index: 2;
    position: absolute;
    right: 30%;
    top: 20%;
    @media${({ theme }) => theme.device['lg']} {
      position: absolute;
      right: 25%;
      top: 20%;
    }
  }
  .left-bottom {
    z-index: 2;
    position: absolute;
    bottom: 15%;
    left: 20%;
    @media${({ theme }) => theme.device['lg']} {
      position: absolute;
      bottom: 5%;
      left: 46%;
    }
  }
  .right-bottom {
    z-index: 2;
    position: absolute;
    right: 20%;
    bottom: 10%;
    @media${({ theme }) => theme.device['lg']} {
      position: absolute;
      right: 25%;
      bottom: 20%;
    }
  }
  .background-text {
    position: absolute;
    z-index: 1;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 2;
`
const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
`

const Error404 = () => {
  const isSmallScreen = useMediaQuery('(max-width:1200px)')
  const navigator = useNavigate()

  useEffect(() => {
    mixpanel.track_pageview({ page: 'Error404' })
    mixpanel.track('Page Not Found')
  }, [])

  return (
    <ErrorContainerWrapper>
      {!isSmallScreen && (
        <Text variant={'h1'} fontSize={'350px'} fontWeight="bold" color={'#F2F4F7'} className="background-text">
          404
        </Text>
      )}
      <Container>
        <Text
          variant={'h2'}
          fontFamily="Ubuntu"
          fontSize={isSmallScreen ? '30px' : '48px'}
          fontWeight="bold"
          color={colors.brandGray900}
        >
          We can’t find this page
        </Text>
        <Text
          variant={'p'}
          fontSize={'18px'}
          my="2rem"
          textAlign="center"
          color={colors.brandGray900}
          data-testid={'error404-paragraph'}
        >
          The page you are looking for doesn&nbsp;t exist or has been moved.
        </Text>
        <ButtonsContainer>
          <Button
            size="small"
            title={'Go Back'}
            icon={<BackIcon size={10} />}
            variant={'secondary'}
            onClick={() => navigator(-1)}
          />
          <Button size="small" title={'Go Home'} variant={'primary'} ml="0.5rem" onClick={() => navigator('/')} />
        </ButtonsContainer>
      </Container>

      <LTSVG className="left-top" />
      <RTSVG className="right-top" />
      <LBSVG className="left-bottom" size={70} />
      <RBSVG className="right-bottom" />
    </ErrorContainerWrapper>
  )
}

export default Error404
